import { Background } from '@sorare/core/src/atoms/ui/Background';
import {
  isSpecialCardSet,
  isSupportedCardSet,
} from '@sorare/core/src/lib/cardSets';

import commonBaseSetBg from './assets/common-base-set-bg.webp';

type Props = {
  set: Nullable<string>;
};

export const CollectionSetBackground = ({ set }: Props) => {
  if (!isSupportedCardSet(set)) {
    return null;
  }
  if (isSpecialCardSet(set)) {
    return <Background name={set} />;
  }
  return <img src={commonBaseSetBg} alt={set} />;
};
